import { mapActions } from 'vuex';
import { $EventBus } from '@/main';

export default {
	name: 'CreateOwnerDialog',
	props: {
		value: {
			type: Boolean,
			required: false,
		},
		fixedType: {
			type: String,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			valid: true,
			loading: false,
			requiredRule: [(v) => !!v || 'Campo requerido'],
			owner_form: {
				name: null,
				document: null,
				type: this.fixedType || null,
			},
			pages: [{ page: 1, content: 'Cotenido 1' }],
			types: [
				{ value: 'PROVIDER', label: 'Proveedor' },
				{ value: 'CLIENT', label: 'Cliente' },
			],
		};
	},
	created() {},
	mounted() {},
	computed: {
		dialog: {
			get() {
				return this.value || false;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		dialogTitle() {
			if (this.fixedType === 'PROVIDER') return 'Agregar proveedor';
			if (this.fixedType === 'CLIENT') return 'Agregar cliente';
			return 'Agregar cliente/proveedor';
		},
	},
	watch: {
		value(newVal) {
			if (newVal) {
				this.cleanForm();
			}
		},
	},
	methods: {
		...mapActions('owner', ['saveOwner']),

		async sendOwner() {
			const isvalidated = this.$refs.addForm.validate();
			if (isvalidated) {
				this.loading = true;
				let data = {
					...this.owner_form,
					type: this.fixedType || this.owner_form.type,
					company_id: parseInt(localStorage.getItem('company_id')),
				};
				const { ok, response, error } = await this.saveOwner(data);
				if (ok) {
					$EventBus.$emit('showSnack', 'success', response.message[0]);
					this.$emit('success');
					this.dialog = false;
				} else {
					this.showError(error);
				}
				this.loading = false;
			}
		},

		showError(error) {
			let msmError = error?.data?.message;
			msmError = Array.isArray(msmError) ? msmError.join(', ') : msmError;
			$EventBus.$emit('showSnack', 'error', msmError);
		},

		cleanForm() {
			this.$nextTick(() => {
				this.owner_form = {
					name: null,
					document: null,
					type: this.fixedType || null,
				};
				if (this.$refs?.addForm) this.$refs.addForm.reset();
			});
		},
	},
	components: {},
};
